var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Active/Dark/Vision",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,-2.64677169e-13 C20.5985546,-2.64677169e-13 21.1356967,0.262937984 21.5022219,0.679609387 L15.6582805,6.52322792 C12.2908047,4.46063638 7.85525401,4.8276811 4.86791291,7.62436208 L4.65194804,7.83333333 L2.19238816,10.2928932 C1.83190419,10.6533772 1.80417466,11.2206082 2.10919955,11.6128994 L2.19238816,11.7071068 L4.65194804,14.1666667 C5.2344884,14.749207 5.87730862,15.2347284 6.56033013,15.6232309 L0.679609387,21.5022219 C0.262937984,21.1356967 -6.57252031e-14,20.5985546 -6.57252031e-14,20 L-6.57252031e-14,2 C-6.57252031e-14,0.8954305 0.8954305,-2.64677169e-13 2,-2.64677169e-13 L20,-2.64677169e-13 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3226125,0.5 C21.7392839,0.866525118 22.0022219,1.40366726 22.0022219,2.00222185 L22.0022219,20.0022219 C22.0022219,21.1067914 21.1067914,22.0022219 20.0022219,22.0022219 L2.00222185,22.0022219 C1.40366726,22.0022219 0.866525118,21.7392839 0.5,21.3226125 L6.33326731,15.4895857 C9.69833364,17.5379307 14.1219482,17.1664766 17.1030928,14.3752232 L17.3186147,14.1666667 L19.7781746,11.7071068 C20.1386586,11.3466228 20.1663881,10.7793918 19.8613632,10.3871006 L19.7781746,10.2928932 L17.3186147,7.83333333 C16.7426197,7.25733837 16.1076919,6.77619442 15.4332406,6.38990148 L21.3226125,0.5 Z",
    id: "Path",
    fill: "#EFEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,6 C13.7614237,6 16,8.23857625 16,11 C16,13.7614237 13.7614237,16 11,16 C8.23857625,16 6,13.7614237 6,11 C6,8.23857625 8.23857625,6 11,6 Z M11,6.625 C8.58375422,6.625 6.625,8.58375422 6.625,11 C6.625,13.4162458 8.58375422,15.375 11,15.375 C13.4162458,15.375 15.375,13.4162458 15.375,11 C15.375,8.58375422 13.4162458,6.625 11,6.625 Z",
    id: "Oval",
    fill: "#EFEFF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,8 C12.6568542,8 14,9.34314575 14,11 C14,11.3080713 13.9535638,11.6052969 13.8673089,11.8850591 C13.6331352,11.3628585 13.1089427,11 12.5,11 C11.6715729,11 11,11.6715729 11,12.5 C11,13.1089427 11.3628585,13.6331352 11.8841496,13.8681515 C11.6052969,13.9535638 11.3080713,14 11,14 C9.34314575,14 8,12.6568542 8,11 C8,9.34314575 9.34314575,8 11,8 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeActive);
export default __webpack_public_path__ + "static/media/eye-active.988f5734caeba8f98cc429ec13231c45.svg";
export { ForwardRef as ReactComponent };